import Episode from 'show-page/components/episode';
import LatestClips from 'show-page/components/latest-clips';
import styles from './styles.less';
import { observer } from 'mobx-react';
import { partition } from 'lodash';


function divideIntoColumns(videos = []) {
    return partition(videos, v => {
        const i = videos.indexOf(v);
        return !Math.floor((i / videos.length) * 2);
    });
}


function Season(props) {
    const { season } = props;
    if (season.videos.length < 1) return null;
    const columns = divideIntoColumns(season.videos);
    return (
        <div className={ cx(styles.root, props.className) }>
            <h3 className={ styles.seasonHeader }>{ season.name }</h3>
            <div className={ styles.videos }>
                { columns.map((videos, i) => (
                    <div
                        className={ styles.column }
                        key={ i }>
                        { videos.map(epi => (
                            <Episode
                                key={ epi.id }
                                highlightColor={ props.highlightColor }
                                rolloverTextColor={ props.rolloverTextColor }
                                onClick={ props.onVideoSelect.bind(null, epi) }
                                selected={ epi.id === props.selectedVideoId }
                                tveAuthenticated={ props.tveAuthenticated }
                                video={ epi }
                            />
                        )) }
                    </div>
                )) }
            </div>
            { !!season.showLatestClips &&
            <LatestClips
                className={ styles.latestClips }
                clipClassName={ styles.clip }
                clips={ season.clips.slice(0, 5) }
                highlightColor={ props.highlightColor }
                onMoreClipsSelect={ props.onMoreClipsSelect }
                onVideoSelect={ props.onVideoSelect }
                rolloverTextColor={ props.rolloverTextColor }
                selectedVideoId={ props.selectedVideoId }
            /> }
        </div>
    );
}

Season.propTypes = {
    highlightColor: React.PropTypes.string.isRequired,
    onMoreClipsSelect: React.PropTypes.func.isRequired,
    onVideoSelect: React.PropTypes.func.isRequired,
    rolloverTextColor: React.PropTypes.string.isRequired,
    selectedVideoId: React.PropTypes.string,
    season: React.PropTypes.object.isRequired
};


export { divideIntoColumns };
export default observer(Season);



// WEBPACK FOOTER //
// ./src/show-page/components/season/index.js